import React from 'react';
import Styles from './item-empty-styles.scss';
const SurveyItemEmpty = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: Styles.surveyItemEmpty }),
        React.createElement("li", { className: Styles.surveyItemEmpty }),
        React.createElement("li", { className: Styles.surveyItemEmpty }),
        React.createElement("li", { className: Styles.surveyItemEmpty })));
};
export default SurveyItemEmpty;
